import React from 'react';

const KeyboardIcon = (props) => (
  <svg width='32px' height='32px' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(6.000000, 9.000000)'>
        <path d='M17,5 L15,5 L15,3 L17,3 M17,8 L15,8 L15,6 L17,6 M14,5 L12,5 L12,3 L14,3 M14,8 L12,8 L12,6 L14,6 M14,12 L6,12 L6,10 L14,10 M5,5 L3,5 L3,3 L5,3 M5,8 L3,8 L3,6 L5,6 M6,6 L8,6 L8,8 L6,8 M6,3 L8,3 L8,5 L6,5 M9,6 L11,6 L11,8 L9,8 M9,3 L11,3 L11,5 L9,5 M18,0 L2,0 C0.89,0 0,0.89 0,2 L0,12 C0,13.1045695 0.8954305,14 2,14 L18,14 C19.1045695,14 20,13.1045695 20,12 L20,2 C20,0.89 19.1,0 18,0 Z' />
      </g>
    </g>
  </svg>
);

export default KeyboardIcon;
